module.exports = __webpack_public_path__ + "assets/3cdb1282c27e5e6335b205fcddc4b7c4.png";